import React from 'react';
import PropTypes from 'prop-types';
import OptimizedImage from './OptimizedImage';
import { BodyText, HeadingText } from '@paypalcorp/pp-react';

const CategoryHeader = props => {
  const {
    title = '',
    subtitle = '',
    body = '',
    imageUrl = '',
    isNewLayoutEligible
  } = props;

  return (
    <section className="width-wrapper">
      {isNewLayoutEligible ? (
        <div className="category-header new">
          <div className="category-image-wrap">
            <OptimizedImage
              imageUrl={imageUrl}
              className={`category-header-image`}
              title={title}
              disableOptimization
            />
          </div>
          <div className="category-text-wrap">
            <div className="category-header-text">
              <HeadingText level={1} >{title}</HeadingText>
              <HeadingText level={2} >{subtitle}</HeadingText>
              <BodyText >{body}</BodyText>
            </div>
          </div>
        </div>
      ) : (
        <div className="category-header">
          <OptimizedImage
            imageUrl={imageUrl}
            className={`category-header-image`}
            title={title}
          />
          <div className="category-header-text">
            <HeadingText level={1} >{title}</HeadingText>
            <HeadingText level={2} >{subtitle}</HeadingText>
            <BodyText >{body}</BodyText>
          </div>
        </div>
      )}
    </section>
  );
};

CategoryHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  body: PropTypes.string,
  imageUrl: PropTypes.string,
  isNewLayoutEligible: PropTypes.bool
};

export default CategoryHeader;
